/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ChatContentPart = {
  /**
   * The text content.
   */
  content: string;
  /**
   * When the content part was created.
   */
  createdAt: Date;
  /**
   * The ID of the content part.
   */
  id: string;
  /**
   * Whether this content part has an active risk finding.
   */
  isRisk: boolean;
  /**
   * The content kind, such as prompt_attachment.
   */
  kind: string;
  /**
   * Sparse metadata for the content kind.
   */
  metadata?: any | undefined;
  /**
   * The chat message this content hangs off, when resolved.
   */
  parentChatMessageId?: string | undefined;
};

/** @internal */
export const ChatContentPart$inboundSchema: z.ZodMiniType<
  ChatContentPart,
  unknown
> = z.pipe(
  z.object({
    content: z.string(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    is_risk: z.boolean(),
    kind: z.string(),
    metadata: z.optional(z.any()),
    parent_chat_message_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "is_risk": "isRisk",
      "parent_chat_message_id": "parentChatMessageId",
    });
  }),
);

export function chatContentPartFromJSON(
  jsonString: string,
): SafeParseResult<ChatContentPart, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ChatContentPart$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ChatContentPart' from JSON`,
  );
}
